module.exports = __webpack_public_path__ + "static/media/sfx_ui_open_kid_area.fc9c031e.mp3";